import { useEffect, useState } from 'react';
export const useText2Telegram = (isTg) => {
    const [textColor, setTextColor] = useState({});
    useEffect(() => {
        const conditionalTextColor = {};
        if (isTg) {
            conditionalTextColor.color = 'var(--tg-theme-button-text-color)';
        }
        setTextColor(conditionalTextColor);
    }, [isTg]);
    return textColor;
};
